"use strict";
import { useMemo } from "react";
export function useMaxAmountIn(trade, allowedSlippage) {
  return useMemo(() => {
    const maximumAmountIn = trade?.maximumAmountIn(allowedSlippage);
    return maximumAmountIn?.currency.isToken ? maximumAmountIn : void 0;
  }, [allowedSlippage, trade]);
}
